import axios from 'axios';
export const baseUrl = "https://landing.benice.ir/";
// export const baseUrl = "https://api.benice.ir/";
axios.defaults.baseURL = baseUrl;

const token = localStorage.getItem('userInfo')
let authHeader = ''
if(token){
   authHeader = {
    'Authorization': 'Bearer ' + JSON.parse(token).token
} 
}

export const GetCustomerInfo = async (mobile) => {
    return await axios.get(baseUrl + `CustomerInfo?Mobile=${mobile}`, {
        headers:
            authHeader
    })
};
export const GetOrders = async (params) => {
    return await axios.get(baseUrl + `CustomerOrders?CustomerId=${params.id}&FromDate=${params.fromDate}&ToDate=${params.toDate}`, {
        headers:
            authHeader
    })
};
export const CustomerShekayat = async (params) => {
    return await axios.get(baseUrl + `CustomerShekayat?Mobile=${params.mobile}&FromDate=${params.fromDate}&ToDate=${params.toDate}`, {
        headers:
            authHeader
    })
};
export const GetTypeShekayat = async (params) => {
    return await axios.get(baseUrl + `TypeShekayat`, {
        headers:
            authHeader
    })
};
export const CheckMobile = async (params) => {
    return await axios.get(baseUrl + `CheckMobile?Mobile=${params}`, {
        headers:
            authHeader
    })
};
export const customerFactor = async (params) => {
    return await axios.get(baseUrl + `CustomerFactor?CustomerId=${params.customerId}&OrderID=${params.orderId}`, {
        headers:
            authHeader
    })
};
export const UpdateCustomer = async (params) => {
    return await axios.post(baseUrl + 'UpdateCustomer', params, {
        headers:
            authHeader
    })
};
export const ChangePass = async (params) => {
    return await axios.post(baseUrl + 'ChangePass', params, {
        headers:
            authHeader
    })
};
export const sendCodeApi = async (params) => {
    return await axios.get(baseUrl + `SendCode?Mobile=${params}`, {
        headers:
            authHeader
    })
};
export const loginApi = async (params) => {
    return await axios.post(baseUrl + `Users/Login `, params, {
        headers:
            authHeader
    })
};

// Product
export const SearchProducts = async (params) => {
    return await axios.post(baseUrl + 'Product/Search', params, {
        headers:
            authHeader
    })
};
export const GetProduct = async (params) => {
    return await axios.get(baseUrl + `Product/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdateProduct = async (params) => {
    return await axios.post(baseUrl + 'Product/Update', params, {
        headers:
            authHeader
    })
};
export const CreateProduct = async (params) => {
    return await axios.post(baseUrl + 'Product/Create', params, {
        headers:
            authHeader
    })
};
export const DeleteProduct = async (params) => {
    return await axios.get(baseUrl + `Product/Delete/${params.id}`, {
        headers:
            authHeader
    })
};


// ProductGroup
export const SearchProductGroup = async (params) => {
    return await axios.post(baseUrl + 'ProductGroup/Search', params, {
        headers:
            authHeader,
    })
};

export const GetProductGroup = async (params) => {
    return await axios.get(baseUrl + `ProductGroup/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdateProductGroup = async (params) => {
    return await axios.post(baseUrl + 'ProductGroup/Update', params, {
        headers:
            authHeader
    })
};
export const CreateProductGroup = async (params) => {
    return await axios.post(baseUrl + 'ProductGroup/Create', params, {
        headers:
            authHeader
    })
};
export const DeleteProductGroup = async (params) => {
    return await axios.get(baseUrl + `ProductGroup/Delete/${params.id}`, {
        headers:
            authHeader
    })
};



// OrderGetway
export const SearchOrderGetway = async (params) => {
    return await axios.post(baseUrl + 'OrderGetway/Search', params, {
        headers:
            authHeader,
    })
};

export const GetOrderGetway = async (params) => {
    return await axios.get(baseUrl + `OrderGetway/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdateOrderGetway = async (params) => {
    return await axios.post(baseUrl + 'OrderGetway/Update', params, {
        headers:
            authHeader
    })
};
export const CreateOrderGetway = async (params) => {
    return await axios.post(baseUrl + 'OrderGetway/Create', params, {
        headers:
            authHeader
    })
};
export const DeleteOrderGetway = async (params) => {
    return await axios.get(baseUrl + `OrderGetway/Delete/${params.id}`, {
        headers:
            authHeader
    })
};




// Branch
export const SearchBranch = async (params) => {
    return await axios.post(baseUrl + 'Branch/Search', params, {
        headers:
            authHeader,
    })
};

export const GetBranch = async (params) => {
    return await axios.get(baseUrl + `Branch/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdateBranch = async (params) => {
    return await axios.post(baseUrl + 'Branch/Update', params, {
        headers:
            authHeader
    })
};
export const CreateBranch = async (params) => {
    return await axios.post(baseUrl + 'Branch/Create', params, {
        headers:
            authHeader
    })
};
export const DeleteBranch = async (params) => {
    return await axios.get(baseUrl + `Branch/Delete/${params.id}`, {
        headers:
            authHeader
    })
};




// About-us
export const SearchAboutUs = async (params) => {
    return await axios.post(baseUrl + 'AboutUs/Search', params, {
        headers:
            authHeader,
    })
};

export const GetAboutUs= async (params) => {
    return await axios.get(baseUrl + `AboutUs/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdateAboutUs = async (params) => {
    return await axios.post(baseUrl + 'AboutUs/Update', params, {
        headers:
            authHeader
    })
};
export const CreateAboutUs = async (params) => {
    return await axios.post(baseUrl + 'AboutUs/Create', params, {
        headers:
            authHeader
    })
};
export const DeleteAboutUs = async (params) => {
    return await axios.get(baseUrl + `AboutUs/Delete/${params.id}`, {
        headers:
            authHeader
    })
};



// Contact
export const SearchContact = async (params) => {
    return await axios.post(baseUrl + 'Contact/Search', params, {
        headers:
            authHeader,
    })
};

export const GetContact= async (params) => {
    return await axios.get(baseUrl + `Contact/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdateContact = async (params) => {
    return await axios.post(baseUrl + 'Contact/Update', params, {
        headers:
            authHeader
    })
};
export const CreateContact = async (params) => {
    return await axios.post(baseUrl + 'Contact/Create', params, {
        headers:
            authHeader
    })
};
export const DeleteContact = async (params) => {
    return await axios.get(baseUrl + `Contact/Delete/${params.id}`, {
        headers:
            authHeader
    })
};


// Popup
export const SearchPopup = async (params) => {
    return await axios.post(baseUrl + 'Popup/Search', params, {
        headers:
            authHeader,
    })
};

export const GetPopup= async (params) => {
    return await axios.get(baseUrl + `Popup/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdatePopup = async (params) => {
    return await axios.post(baseUrl + 'Popup/Update', params, {
        headers:
            authHeader
    })
};
export const CreatePopup = async (params) => {
    return await axios.post(baseUrl + 'Popup/Create', params, {
        headers:
            authHeader
    })
};
export const DeletePopup = async (params) => {
    return await axios.get(baseUrl + `Popup/Delete/${params.id}`, {
        headers:
            authHeader
    })
};


// Department
export const SearchDepartment = async (params) => {
    return await axios.post(baseUrl + 'Department/Search', params, {
        headers:
            authHeader,
    })
};

export const GetDepartment= async (params) => {
    return await axios.get(baseUrl + `Department/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdateDepartment = async (params) => {
    return await axios.post(baseUrl + 'Department/Update', params, {
        headers:
            authHeader
    })
};
export const CreateDepartment = async (params) => {
    return await axios.post(baseUrl + 'Department/Create', params, {
        headers:
            authHeader
    })
};
export const DeleteDepartment = async (params) => {
    return await axios.get(baseUrl + `Department/Delete/${params.id}`, {
        headers:
            authHeader
    })
};


// Subject
export const SearchSubject = async (params) => {
    return await axios.post(baseUrl + 'Subject/Search', params, {
        headers:
            authHeader,
    })
};

export const GetSubject= async (params) => {
    return await axios.get(baseUrl + `Subject/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdateSubject = async (params) => {
    return await axios.post(baseUrl + 'Subject/Update', params, {
        headers:
            authHeader
    })
};
export const CreateSubject = async (params) => {
    return await axios.post(baseUrl + 'Subject/Create', params, {
        headers:
            authHeader
    })
};
export const DeleteSubject = async (params) => {
    return await axios.get(baseUrl + `Subject/Delete/${params.id}`, {
        headers:
            authHeader
    })
};



// Introduction
export const SearchIntroduction = async (params) => {
    return await axios.post(baseUrl + 'Introduction/Search', params, {
        headers:
            authHeader,
    })
};

export const GetIntroduction= async (params) => {
    return await axios.get(baseUrl + `Introduction/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdateIntroduction = async (params) => {
    return await axios.post(baseUrl + 'Introduction/Update', params, {
        headers:
            authHeader
    })
};
export const CreateIntroduction = async (params) => {
    return await axios.post(baseUrl + 'Introduction/Create', params, {
        headers:
            authHeader
    })
};
export const DeleteIntroduction = async (params) => {
    return await axios.get(baseUrl + `Introduction/Delete/${params.id}`, {
        headers:
            authHeader
    })
};
// Hire
export const SearchHire = async (params) => {
    return await axios.post(baseUrl + 'Hire/Search', params, {
        headers:
            authHeader,
    })
};

// Contact-us
export const SearchContactUs = async (params) => {
    return await axios.post(baseUrl + 'ContactUs/Search', params, {
        headers:
            authHeader,
    })
};

// ProductUserComment
export const SearchProductUserComment = async (params) => {
    return await axios.post(baseUrl + 'ProductUserComment/Search', params, {
        headers:
            authHeader,
    })
};
export const deleteProductUserComment = async (params) => {
    return await axios.get(baseUrl + `ProductUserComment/Delete/${params.id}`, {
        headers:
            authHeader,
    })
};
// File
export const AttachFileCreate = async (params) => {
    return await axios.post(baseUrl + 'AttachFile/Create', params, {
        headers:
            authHeader,
    })
};

export const AttachFileUpdate = async (params) => {
    return await axios.post(baseUrl + 'AttachFile/Update', params, {
        headers:
            authHeader,
    })
};

export const AttachFileDelete = async (params) => {
    return await axios.post(baseUrl + `AttachFile/Delete/${params.id}`, {  }, {
        headers:
            authHeader,
    })
};




// Company | Customer
export const CreateCompany = async (params) => {
    return await axios.post(baseUrl + `Company/Create`, params, {
        headers:
            authHeader,
    })
};
export const SearchCompany = async (params) => {
    return await axios.post(baseUrl + `Company/Search`, params, {
        headers:
            authHeader,
    })
};
export const DeleteCompany = async (params) => {
    return await axios.get(baseUrl + `Company/Delete/${params.id}`, {
        headers:
            authHeader
    })
};


// Banner

export const CreateBanner = async (params) => {
    return await axios.post(baseUrl + `Banner/Create`, params, {
        headers:
            authHeader,
    })
};
export const IsDefultBanner = async (params) => {
    return await axios.post(baseUrl + `Banner/SetDefualt`, params, {
        headers:
            authHeader,
    })
};

export const SearchBanner = async (params) => {
    return await axios.get(baseUrl + `Banner/${params.slug}`, params, {
        headers:
        authHeader,
    })
};

export const DeleteBanner = async (params) => {
    return await axios.post(baseUrl + `Banner/Delete/${params.id}`, { id: params.id }, {
        headers:
            authHeader,
    })
};




// FoundUs
export const SearchFoundUs = async (params) => {
    return await axios.post(baseUrl + 'FoundUs/Search', params, {
        headers:
            authHeader,
    })
};

export const GetFoundUs= async (params) => {
    return await axios.get(baseUrl + `FoundUs/${params.id}`, {
        headers:
            authHeader
    })
};
export const UpdateFoundUs = async (params) => {
    return await axios.post(baseUrl + 'FoundUs/Update', params, {
        headers:
            authHeader
    })
};
export const CreateFoundUs = async (params) => {
    return await axios.post(baseUrl + 'FoundUs/Create', params, {
        headers:
            authHeader
    })
};
export const DeleteFoundUs = async (params) => {
    return await axios.get(baseUrl + `FoundUs/Delete/${params.id}`, {
        headers:
            authHeader
    })
};



// WeblogAndNews
export const CreateWeblogAndNews = async (params) => {
    return await axios.post(baseUrl + `WeblogAndNews/Create`, params, {
        headers:
            authHeader,
    })
};

export const UpdateWeblogAndNews = async (params) => {
    return await axios.post(baseUrl + `WeblogAndNews/Update`, params, {
        headers:
            authHeader,
    })
};

export const SearchWeblogAndNews = async (params) => {
    return await axios.post(baseUrl + `WeblogAndNews/Search`, params, {
        headers:
            authHeader,
    })
};

export const DeleteWeblogAndNews = async (params) => {
    return await axios.get(baseUrl + `WeblogAndNews/Delete/${params.id}`, {
        headers:
            authHeader
    })
};



// const api = async (method, url, params = null) => {
//     if (method === 'get') {
//         // if params exist, must be passed as string url query like 'mobile=09374008234&gender=m'
//         return await axios.get(`${url}?${!!params?params:''}`, { headers: authHeader, withCredentials:false, });
//     }
//     else if (method === 'post') {
//         return await axios.post(url, params, { headers: authHeader, withCredentials:false });
//     }
// };
// export const GetCustomerInfo = async(query) => {
// await api('get' , 'CustomerInfo' , query)
// }